/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Discount<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Discount
   * @name ValidateList
   * @request GET:/Discount/Validate
   */
  validateList = (query: { code: string; product: number }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Discount/Validate`,
      method: "GET",
      query: query,
      ...params,
    });
}
